(() => {
  document.documentElement.classList.add('tx-premium-ready');

  const markExternal = () => document.querySelectorAll('a[target="_blank"]').forEach(link => {
    if (!link.rel.includes('noopener')) link.rel = `${link.rel} noopener noreferrer`.trim();
  });

  const labelProductForms = () => document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
    if (!form.getAttribute('aria-label')) form.setAttribute('aria-label', 'Add product to cart');
  });

  const replaceTextNodes = (root, replacements) => {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(node => {
      let value = node.nodeValue;
      replacements.forEach(([pattern, replacement]) => {
        value = value.replace(pattern, replacement);
      });
      if (value !== node.nodeValue) node.nodeValue = value;
    });
  };

  const correctDefaultMattressBrandDelivery = () => {
    const productTitle = document.querySelector('.t4s-product__title, h1');
    const croRoot = document.querySelector('.tx-product-guide');
    if (!productTitle || !croRoot) return;

    const title = (productTitle.textContent || '').trim();
    let brand = '';
    if (/^sealy\b/i.test(title)) brand = 'Sealy';
    else if (/^(tempur|tempur-pedic)\b/i.test(title)) brand = 'TEMPUR-Pedic';
    else if (/^stearns\s*&\s*foster\b/i.test(title)) brand = 'Stearns & Foster';
    if (!brand) return;

    replaceTextNodes(croRoot, [
      [/^Delivery options by product$/gi, 'Delivery options by product'],
      [/Ships nationwide by UPS or FedEx; local setup options may be available\./gi, 'Delivery and setup terms vary by product and destination.'],
      [/Free nationwide UPS\/FedEx delivery for this item\./gi, 'Delivery options by product for this brand.']
    ]);

    croRoot.querySelectorAll('dt').forEach(dt => {
      if ((dt.textContent || '').trim().toLowerCase() !== 'brand') return;
      const dd = dt.nextElementSibling;
      if (dd && /texan mattress/i.test(dd.textContent || '')) dd.textContent = brand;
    });
  };

  const correctCollectionCardBrands = () => {
    document.querySelectorAll('.tx-mattress-card[data-tx-brand]').forEach(detail => {
      const brand = (detail.getAttribute('data-tx-brand') || '').trim();
      if (!brand || /^texan mattress$/i.test(brand)) return;

      const card = detail.closest('.tx-is-mattress');
      if (!card || card.dataset.txBrandCorrected === brand) return;

      const vendorLink = card.querySelector('.t4s-product-vendor a');
      if (!vendorLink || !/texan mattress/i.test(vendorLink.textContent || '')) return;

      vendorLink.textContent = brand;
      const titleLink = card.querySelector('.t4s-product-title a[data-pr-href], .t4s-product-title a');
      if (titleLink && titleLink.href) vendorLink.href = titleLink.href;
      vendorLink.setAttribute('aria-label', `${brand} mattress details`);
      card.dataset.txBrandCorrected = brand;
    });
  };

  let collectionBrandTimer;
  const scheduleCollectionBrandCorrection = () => {
    window.clearTimeout(collectionBrandTimer);
    collectionBrandTimer = window.setTimeout(correctCollectionCardBrands, 80);
  };

  const watchCollectionCards = () => {
    const main = document.getElementById('MainContent');
    if (!main || !('MutationObserver' in window)) return;
    const observer = new MutationObserver(scheduleCollectionBrandCorrection);
    observer.observe(main, { childList: true, subtree: true });
  };

  const applyLaunchQAHotfix = () => {
    replaceTextNodes(document.getElementById('t4s-top-bar-main'), [
      [/Delivery & Setup Options/gi, 'Delivery Options by Product'],
      [/Delivery & Setup Options/gi, 'Delivery Options by Product']
    ]);
    correctDefaultMattressBrandDelivery();
  };

  document.addEventListener('DOMContentLoaded', () => {
    markExternal();
    labelProductForms();
    applyLaunchQAHotfix();
    correctCollectionCardBrands();
    watchCollectionCards();
  });
})();

/* Custom product template rescue: Avocado, WinkBed and Helix legacy PDPs.
   The default product template is explicitly excluded. */
(() => {
  const isCustomProductPage = () => {
    const body = document.body;
    return !!body && body.classList.contains('template-product') && !body.classList.contains('product-default-template');
  };

  const installRescueStyles = () => {
    if (document.getElementById('tx-custom-product-rescue-styles')) return;
    const style = document.createElement('style');
    style.id = 'tx-custom-product-rescue-styles';
    style.textContent = `
      body.template-product:not(.product-default-template) .t4s-section-main-product .t4s-product__media-wrapper,
      body.template-product:not(.product-default-template) .t4s-section-main-product .t4s-product__info-wrapper,
      body.template-product:not(.product-default-template) .t4s-section-main-product .t4s-product__info-container,
      body.template-product:not(.product-default-template) .t4s-section-main-product [hdt-reveal],
      body.template-product:not(.product-default-template) .t4s-section-main-product [timeline],
      body.template-product:not(.product-default-template) .t4s-section-main-product .t4s-product__price-review,
      body.template-product:not(.product-default-template) .t4s-section-main-product .t4s-product-form__variants,
      body.template-product:not(.product-default-template) .t4s-section-main-product .t4s-product-form__buttons {
        opacity: 1 !important;
        visibility: visible !important;
        transform: none !important;
      }
      body.template-product:not(.product-default-template) .t4s-section-main-product .t4s-product-price {
        display: block !important;
        opacity: 1 !important;
        visibility: visible !important;
        color: #222 !important;
      }
      body.template-product:not(.product-default-template) .t4s-section-main-product .t4s-product__media-wrapper img[data-master] {
        opacity: 1 !important;
        visibility: visible !important;
      }
    `;
    document.head.appendChild(style);
  };

  const usableCdnUrl = (master, width) => {
    if (!master) return '';
    try {
      const url = new URL(master, window.location.origin);
      if (url.hostname.includes('cdn.shopify.com')) url.searchParams.set('width', String(width || 1200));
      return url.toString();
    } catch (_) {
      return master;
    }
  };

  const loadRealImage = (img, width, eager) => {
    if (!img || !img.dataset || !img.dataset.master) return;
    const realSrc = usableCdnUrl(img.dataset.master, width);
    if (!realSrc) return;
    const current = img.getAttribute('src') || '';
    const looksLikePlaceholder = !current || /^data:image\/svg/i.test(current) || /width=1(?:&|$)/.test(current);
    if (looksLikePlaceholder || img.naturalWidth <= 2) {
      img.src = realSrc;
      img.removeAttribute('srcset');
    }
    if (eager) {
      img.loading = 'eager';
      try { img.fetchPriority = 'high'; } catch (_) {}
    }
    img.classList.remove('lazyloadt4s', 'lazyloading');
    img.classList.add('lazyloaded');
    img.style.setProperty('opacity', '1', 'important');
    img.style.setProperty('visibility', 'visible', 'important');
  };

  let mediaObserver;
  let rootObserver;
  let rescueTimer;

  const rescueCustomProduct = () => {
    if (!isCustomProductPage()) return;
    installRescueStyles();

    const root = document.querySelector('.t4s-section-main-product');
    if (!root) return;

    root.querySelectorAll('.t4s-product__media-wrapper, .t4s-product__info-wrapper, .t4s-product__info-container, [hdt-reveal], [timeline], .t4s-product__price-review, .t4s-product-price, .t4s-product-form__variants, .t4s-product-form__buttons').forEach(el => {
      el.hidden = false;
      el.style.setProperty('opacity', '1', 'important');
      el.style.setProperty('visibility', 'visible', 'important');
      el.style.setProperty('transform', 'none', 'important');
    });

    const images = Array.from(root.querySelectorAll('.t4s-product__media-wrapper img[data-master]'));
    const firstVisible = images.find(img => !img.closest('.is--media-hide')) || images[0];
    if (firstVisible) loadRealImage(firstVisible, 1400, true);

    if ('IntersectionObserver' in window) {
      if (mediaObserver) mediaObserver.disconnect();
      mediaObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          loadRealImage(entry.target, 1100, false);
          mediaObserver.unobserve(entry.target);
        });
      }, { rootMargin: '400px 0px' });
      images.forEach(img => { if (img !== firstVisible) mediaObserver.observe(img); });
    } else {
      images.slice(1, 4).forEach(img => loadRealImage(img, 1000, false));
    }

    const price = root.querySelector('.t4s-product-price');
    if (price) {
      price.hidden = false;
      price.style.setProperty('display', 'block', 'important');
      price.style.setProperty('opacity', '1', 'important');
      price.style.setProperty('visibility', 'visible', 'important');
    }

    if (!rootObserver && 'MutationObserver' in window) {
      rootObserver = new MutationObserver(() => {
        window.clearTimeout(rescueTimer);
        rescueTimer = window.setTimeout(rescueCustomProduct, 60);
      });
      rootObserver.observe(root, { childList: true, subtree: true });
    }
  };

  const boot = () => {
    if (!isCustomProductPage()) return;
    rescueCustomProduct();
    window.setTimeout(rescueCustomProduct, 250);
    window.setTimeout(rescueCustomProduct, 900);
    window.setTimeout(rescueCustomProduct, 1800);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  window.addEventListener('load', rescueCustomProduct, { once: true });
  document.addEventListener('shopify:section:load', rescueCustomProduct);
})();
